import React from 'react';
import { Web3ReactProvider } from '@web3-react/core';
import { useWeb3Eager } from '@sc1/common/hooks';
import { ThemeProvider } from 'theme-ui';
import { Header, Footer, Flex, Box } from '@components';
import { ApolloProvider } from '@apollo/react-hooks';
import { createClient } from '@sc1/common/utils/apolloClient';
import { providers } from 'ethers';
import { BrowserRouter as Router } from 'react-router-dom';
import { Routes } from './Routes';
import { Sector } from '../components/alerts';
import { Toaster } from 'react-hot-toast';
import { theme } from '../styles';
import { ModalProvider, Web3Provider } from '../context';

function getLibrary(provider: any): providers.Web3Provider {
  const library = new providers.Web3Provider(provider);
  library.polling = true;
  library.pollingInterval = 1000;
  return library;
}

const client = createClient();

export const App = (): JSX.Element => (
  <ApolloProvider client={client}>
    <ThemeProvider
      // @ts-ignore
      theme={theme}
    >
      <Web3ReactProvider getLibrary={getLibrary}>
        <Web3Provider>
          <Toaster containerStyle={{ top: 60 }} />
          <InitWeb />
          <Router>
            <ModalProvider>
              <Flex sx={{ flexDirection: 'column', minHeight: '100vh' }}>
                <Sector />
                <Header />
                <Box mb={[4, 5]} />
                <Routes />
                <Box mb={4} />
              </Flex>
              <Footer />
            </ModalProvider>
          </Router>
        </Web3Provider>
      </Web3ReactProvider>
    </ThemeProvider>
  </ApolloProvider>
);

function InitWeb() {
  useWeb3Eager();
  return null;
}
